import { RollingDateOptions, RollingDateOptionsValues } from 'customer-data-filters-ui/public/constants';

// NOTE: Don't assume that default exists, always check first
export const DEFAULT = 'default';
export const CUSTOM_DATE_OPTION = 'CUSTOM';

/* FMO survey values */
export const QA_FMO_SURVEY_ID = 427;
export const PROD_FMO_SURVEY_ID = 1160;

/** Maps to property name in query, state properties */
export const FILTERS = {
  IS_DEAL_CLOSED: 'is_deal_closed',
  TEAM: 'team',
  FORECAST_TYPE: 'forecast_type',
  PIPELINE: 'pipeline',
  DEAL_GROUPING: 'deal_grouping',
  DEAL_STAGE_GROUPINGS: 'deal_stage_groupings',
  FORECAST_CATEGORY_GROUPINGS: 'forecast_category_groupings',
  DEAL_GROUPING_TYPE: 'deal_grouping_type',
  TIME_PERIOD: 'time_period',
  OWNERS: 'owners',
  OBJECT_ID: 'deal_id'
};
export const ADDITIONAL_QUERY_PARAMS = {
  CONTINUE_SETUP: 'continue_setup'
};
export const FILTERS_PROPERTY_NAME = {
  [FILTERS.IS_DEAL_CLOSED]: 'hs_is_closed',
  [FILTERS.TEAM]: 'hubspot_team_id',
  [FILTERS.PIPELINE]: 'pipeline',
  [FILTERS.OWNERS]: 'hubspot_owner_id',
  [FILTERS.OBJECT_ID]: 'hs_object_id'
};

// TODO 2508: investigate deleting this object entirely
// https://git.hubteam.com/HubSpot/forecasting-team/issues/2508
export const TIME_PERIOD_FILTERS = {
  LAST_MONTH: RollingDateOptionsValues.LAST_MONTH,
  THIS_MONTH: RollingDateOptionsValues.THIS_MONTH,
  NEXT_MONTH: RollingDateOptionsValues.NEXT_MONTH,
  LAST_QUARTER: RollingDateOptionsValues.LAST_QUARTER,
  LAST_FISCAL_QUARTER: RollingDateOptionsValues.LAST_FISCAL_QUARTER,
  THIS_QUARTER: RollingDateOptionsValues.THIS_QUARTER,
  THIS_FISCAL_QUARTER: RollingDateOptionsValues.THIS_FISCAL_QUARTER,
  NEXT_QUARTER: RollingDateOptionsValues.NEXT_QUARTER,
  NEXT_FISCAL_QUARTER: RollingDateOptionsValues.NEXT_FISCAL_QUARTER,
  LAST_YEAR: RollingDateOptionsValues.LAST_YEAR,
  LAST_FISCAL_YEAR: RollingDateOptionsValues.LAST_FISCAL_YEAR,
  THIS_YEAR: RollingDateOptionsValues.THIS_YEAR,
  THIS_FISCAL_YEAR: RollingDateOptionsValues.THIS_FISCAL_YEAR,
  NEXT_YEAR: RollingDateOptionsValues.NEXT_YEAR,
  NEXT_FISCAL_YEAR: RollingDateOptionsValues.NEXT_FISCAL_YEAR
};
export const TIME_PERIOD_FILTER_CUSTOM = {
  [CUSTOM_DATE_OPTION]: CUSTOM_DATE_OPTION
};
export const TIME_PERIOD_FILTERS_TO_OPTION_TEXT_STRINGS = {
  [TIME_PERIOD_FILTERS.LAST_MONTH]: RollingDateOptions.LAST_MONTH.textToken,
  [TIME_PERIOD_FILTERS.THIS_MONTH]: RollingDateOptions.THIS_MONTH.textToken,
  [TIME_PERIOD_FILTERS.NEXT_MONTH]: RollingDateOptions.NEXT_MONTH.textToken,
  [TIME_PERIOD_FILTERS.LAST_QUARTER]: RollingDateOptions.LAST_QUARTER.textToken,
  [TIME_PERIOD_FILTERS.LAST_FISCAL_QUARTER]: RollingDateOptions.LAST_FISCAL_QUARTER.textToken,
  [TIME_PERIOD_FILTERS.THIS_QUARTER]: RollingDateOptions.THIS_QUARTER.textToken,
  [TIME_PERIOD_FILTERS.THIS_FISCAL_QUARTER]: RollingDateOptions.THIS_FISCAL_QUARTER.textToken,
  [TIME_PERIOD_FILTERS.NEXT_QUARTER]: RollingDateOptions.NEXT_QUARTER.textToken,
  [TIME_PERIOD_FILTERS.NEXT_FISCAL_QUARTER]: RollingDateOptions.NEXT_FISCAL_QUARTER.textToken,
  [TIME_PERIOD_FILTERS.LAST_YEAR]: RollingDateOptions.LAST_YEAR.textToken,
  [TIME_PERIOD_FILTERS.LAST_FISCAL_YEAR]: RollingDateOptions.LAST_FISCAL_YEAR.textToken,
  [TIME_PERIOD_FILTERS.THIS_YEAR]: RollingDateOptions.THIS_YEAR.textToken,
  [TIME_PERIOD_FILTERS.THIS_FISCAL_YEAR]: RollingDateOptions.THIS_FISCAL_YEAR.textToken,
  [TIME_PERIOD_FILTERS.NEXT_YEAR]: RollingDateOptions.NEXT_YEAR.textToken,
  [TIME_PERIOD_FILTERS.NEXT_FISCAL_YEAR]: RollingDateOptions.NEXT_FISCAL_YEAR.textToken,
  [CUSTOM_DATE_OPTION]: 'repOverviewTable.filters.timePeriod.custom.label'
};
export const NON_FISCAL_FILTERS = [TIME_PERIOD_FILTERS.LAST_QUARTER, TIME_PERIOD_FILTERS.THIS_QUARTER, TIME_PERIOD_FILTERS.NEXT_QUARTER, TIME_PERIOD_FILTERS.LAST_YEAR, TIME_PERIOD_FILTERS.THIS_YEAR, TIME_PERIOD_FILTERS.NEXT_YEAR];
export const FISCAL_FILTERS = [TIME_PERIOD_FILTERS.LAST_FISCAL_QUARTER, TIME_PERIOD_FILTERS.THIS_FISCAL_QUARTER, TIME_PERIOD_FILTERS.NEXT_FISCAL_QUARTER, TIME_PERIOD_FILTERS.LAST_FISCAL_YEAR, TIME_PERIOD_FILTERS.THIS_FISCAL_YEAR, TIME_PERIOD_FILTERS.NEXT_FISCAL_YEAR];
export const FISCAL_TO_NON_FISCAL_FILTERS_MAP = {
  [TIME_PERIOD_FILTERS.LAST_QUARTER]: TIME_PERIOD_FILTERS.LAST_FISCAL_QUARTER,
  [TIME_PERIOD_FILTERS.THIS_QUARTER]: TIME_PERIOD_FILTERS.THIS_FISCAL_QUARTER,
  [TIME_PERIOD_FILTERS.NEXT_QUARTER]: TIME_PERIOD_FILTERS.NEXT_FISCAL_QUARTER,
  [TIME_PERIOD_FILTERS.LAST_YEAR]: TIME_PERIOD_FILTERS.LAST_FISCAL_YEAR,
  [TIME_PERIOD_FILTERS.THIS_YEAR]: TIME_PERIOD_FILTERS.THIS_FISCAL_YEAR,
  [TIME_PERIOD_FILTERS.NEXT_YEAR]: TIME_PERIOD_FILTERS.NEXT_FISCAL_YEAR,
  [TIME_PERIOD_FILTERS.LAST_FISCAL_QUARTER]: TIME_PERIOD_FILTERS.LAST_QUARTER,
  [TIME_PERIOD_FILTERS.THIS_FISCAL_QUARTER]: TIME_PERIOD_FILTERS.THIS_QUARTER,
  [TIME_PERIOD_FILTERS.NEXT_FISCAL_QUARTER]: TIME_PERIOD_FILTERS.NEXT_QUARTER,
  [TIME_PERIOD_FILTERS.LAST_FISCAL_YEAR]: TIME_PERIOD_FILTERS.LAST_YEAR,
  [TIME_PERIOD_FILTERS.THIS_FISCAL_YEAR]: TIME_PERIOD_FILTERS.THIS_YEAR,
  [TIME_PERIOD_FILTERS.NEXT_FISCAL_YEAR]: TIME_PERIOD_FILTERS.NEXT_YEAR
};
export const FILTER_STORAGE_KEY = 'Forecasting:Filters';
export const NO_VALUE_SELECTED = '-1';
export const ONE = 'one'; // Deal Stage
export const MULTI = 'multi'; // Forecast Category
export const ONE_OR_ALL = 'oneOrAll'; // Analyze